'use client'

import { BasicFormValues } from '@app/registration/_components/basic/initialFormValues'
import { DatePicker } from '@internations/ds'
import { trackEvent as trackGAEvent } from '@tracking/gtag'
import { useField, useFormikContext } from '@util/Formik'
import dayjs, { Dayjs } from '@util/dayjs'
import { birthdayMax } from '@util/registration/BasicFormModel'
import type { JSX } from 'react'
import { useEffect } from 'react'

const RegistrationBirthdayDatePicker = (): JSX.Element => {
    const [{ value }, { error, touched }, { setValue: setDate }] = useField<BasicFormValues['birthday']>('birthday')
    const { handleBlur } = useFormikContext()
    const hasError = Boolean(touched && error)

    useEffect(() => {
        if (hasError) {
            trackGAEvent({
                eventName: 'birthday_error',
                eventParams: {
                    event_category: 'registration',
                    event_label: 'rs06b',
                },
            })
        }
    }, [hasError])

    const onDateChange = (date: Dayjs | null) => {
        if (!dayjs.isDayjs(date)) {
            setDate(undefined, true)
            return
        }

        setDate(date, true)
    }

    return (
        <DatePicker
            value={dayjs.isDayjs(value) ? value : null}
            onChange={onDateChange}
            openTo="year"
            views={['year', 'month', 'day']}
            minDate={dayjs().subtract(100, 'year')}
            maxDate={birthdayMax}
            label="Birthday"
            format="DD/MM/YYYY"
            closeOnSelect={true}
            slotProps={{
                actionBar: {
                    actions: ['clear', 'cancel', 'accept'],
                },
                textField: {
                    name: 'birthday',
                    onBlur: handleBlur,
                    fullWidth: true,
                    error: hasError,
                    helperText: hasError ? error : null,
                    inputProps: {
                        'data-testid': 'birthdayDatepicker',
                    },
                },
            }}
        />
    )
}

export default RegistrationBirthdayDatePicker
